import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import {
  LayoutDashboard,
  AlertTriangle,
  Shield,
  Lock,
  TrendingUp,
  Settings,
} from 'lucide-react'

const Sidebar: React.FC = () => {
  const location = useLocation()

  const navItems = [
    { path: '/', label: 'Dashboard', icon: LayoutDashboard },
    { path: '/breach-events', label: 'Breach Events', icon: AlertTriangle },
    { path: '/monitored-accounts', label: 'Monitored Accounts', icon: Shield },
    { path: '/account-lockout', label: 'Account Lockout', icon: Lock },
    { path: '/risk-trends', label: 'Risk Trends', icon: TrendingUp },
    { path: '/settings', label: 'Settings', icon: Settings },
  ]

  return (
    <aside className="w-64 bg-background-secondary border-r border-zinc-700 flex flex-col">
      {/* Logo */}
      <div className="p-6 border-b border-zinc-700">
        <div className="text-2xl font-bold text-text-primary">DarkSentinel</div>
        <p className="text-xs text-text-muted mt-1">Breach Monitoring</p>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4">
        <ul className="space-y-1">
          {navItems.map((item) => {
            const Icon = item.icon
            const isActive = location.pathname === item.path

            return (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className={`
                    flex items-center gap-3 px-4 py-3 rounded-md transition-colors
                    ${
                      isActive
                        ? 'bg-accent-primary text-white'
                        : 'text-text-secondary hover:bg-background-tertiary hover:text-text-primary'
                    }
                  `}
                >
                  <Icon className="w-5 h-5" />
                  <span className="font-medium">{item.label}</span>
                </Link>
              </li>
            )
          })}
        </ul>
      </nav>

      {/* Footer */}
      <div className="p-4 border-t border-zinc-700">
        <p className="text-xs text-text-muted text-center">v0.3.0-phase3</p>
      </div>
    </aside>
  )
}

export default Sidebar
